import PageLayout from "templates/PageLayout/PageLayout"
export default PageLayout
